export default __webpack_public_path__ + "static/media/not_started-24px.55ed6187.svg";